var i = function() {
  function e(t, s) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = s;
  }
  return e;
}();
export {
  i as ResizeObserverDetail
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/ResizeObserverDetail.js
// module id = 1306
// module chunks = 41